import { useState } from 'react';

import Input from '@cartwhl/ui/atoms/Input';
import Text from '@cartwhl/ui/base/Text';
import Button from '@cartwhl/ui/input/Button';
import Modal from '@cartwhl/ui/molecules/Modal';

import { noticesStore, userStore } from 'stores/global';

import PlanFeatures from './PlanFeatures';

export default function AssignSeatModal({
  close,
  seatType,
}: {
  close: () => void;
  seatType: 'pro' | 'unlimited';
}) {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);

  function handleOpenChange(open: boolean) {
    if (!open) close();
  }

  const handleSendInvite = async () => {
    if (!email) return;
    setSubmitting(true);
    const ok = await userStore.assignSeatToUser(email, seatType);
    setSubmitting(false);
    if (ok) {
      noticesStore.success('Invite sent');
      close();
    }
  };

  const planLabel = seatType === 'unlimited' ? 'Unlimited' : 'Professional';

  return (
    <Modal
      title="Assign empty seat"
      maxWidth={684}
      open={true}
      onOpenChange={handleOpenChange}
    >
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-2">
          <Text as="label" variant="studio/body/sm">
            User email
          </Text>
          <Input
            name="assign-seat-email"
            placeholder="name@company.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div className="border-gray-30 dark:border-gray-60 flex items-center justify-between rounded-lg border p-4">
          <PlanFeatures plan={planLabel} />
        </div>

        <div className="mt-2 flex flex-row flex-nowrap">
          <Button variant="secondary" onClick={close} disabled={submitting}>
            Cancel
          </Button>
          <Button
            className="ml-auto"
            variant="primary"
            onClick={handleSendInvite}
            disabled={submitting || !email}
          >
            Send invite
          </Button>
        </div>
      </div>
    </Modal>
  );
}
